import { render, staticRenderFns } from "./customerSer.vue?vue&type=template&id=43ab0638&scoped=true&"
import script from "./customerSer.vue?vue&type=script&lang=js&"
export * from "./customerSer.vue?vue&type=script&lang=js&"
import style0 from "./customerSer.vue?vue&type=style&index=0&id=43ab0638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ab0638",
  null
  
)

export default component.exports